import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    svg: {
        width: 'auto',
        height: 28,
        overflow: 'visible',
    },
});

const LogoIcon = () => {
    const classes = useStyles();

    return (
        <svg
            className={classes.svg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -3 34 30"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                fill="#569715"
                d="M15.805 28.333c8.824 0 15.805-6.892 15.805-15.716S24.629-3.1 15.804-3.1C7.024-3.1 0 3.791 0 12.617s7.024 15.716 15.804 15.716m0-4.214c-6.452 0-11.501-5.05-11.501-11.502S9.351 1.114 15.805 1.114c6.497 0 11.502 5.05 11.502 11.503S22.302 24.12 15.805 24.12"
            />
            <path
                fill="#569715"
                d="M14.251 20.726c-.98-.32-1.815-.77-1.815-.98 0-.132.102-.533.227-.89.21-.605.179-.7-.454-1.355-.743-.77-1.08-.798-2.428-.205l-.74.326-.52-.888c-.286-.49-.52-.986-.52-1.104s.409-.407.909-.642c.997-.47 1.192-.876.948-1.975-.17-.77-.414-.953-1.505-1.127-.665-.106-.756-.19-.756-.686 0-.31.1-.853.223-1.204l.222-.64 1.26.13 1.26.13.568-.744.568-.744-.438-.9c-.24-.494-.437-.99-.437-1.1s.428-.472.952-.804l.95-.603.779.91c.702.82.865.91 1.656.91 1.03 0 1.44-.333 1.626-1.32.073-.385.208-.747.3-.805.2-.123 2.028.296 2.28.524.099.088.032.58-.15 1.117-.293.86-.296 1.007-.022 1.424.168.256.533.615.81.798.476.31.574.305 1.597-.086.868-.332 1.133-.365 1.3-.162.21.25.826 1.62.826 1.832 0 .06-.365.255-.812.434-.447.18-.9.49-1.008.69-.23.43-.255 1.606-.042 1.926.23.346.98.685 1.513.685.266 0 .534.05.594.11.162.162-.225 1.54-.558 1.992-.262.355-.376.368-1.333.147-1.04-.24-1.05-.238-1.716.407-.748.725-.816 1.114-.355 2.006.355.686.256.895-.767 1.623l-.588.42-.77-.753c-.718-.7-.83-.742-1.613-.61-.756.128-.882.235-1.223 1.03-.21.488-.406.88-.438.87zm3.157-5.24c1.01-.48 1.726-1.52 1.83-2.652.24-2.66-2.737-4.548-5.07-3.215-1.157.663-1.591 1.362-1.686 2.716-.068.972-.003 1.277.395 1.863 1.045 1.54 2.894 2.064 4.53 1.287"
            />
        </svg>
    );
};

export default LogoIcon;
